// Vendored from gs-ui-templates/src/components/WhatsappEditor/markdownToHtml.ts.
// The 5 regexes below are copied verbatim (lookbehind and all) from
// gs-ui-templates/src/components/WhatsappEditor/config.ts, inlined here instead of a
// separate config module since this is the only thing in this port that needs them.
const LIST_ITEM_REGEX = /^\s*([-*]|\d+\.)\s(\S.*)$/;
const BOLD_REGEX = /(?<![a-zA-Z0-9])\*([^\s].*?[^\s]|\S|w)\*(?=[\W_]|\s|$)/g;
const ITALIC_REGEX = /(?<![a-zA-Z0-9])_([^\s].*?[^\s]|\S|w)_(?=[\W_]|\s|$)/g;
const STRIKETHROUGH_REGEX = /(?<![a-zA-Z0-9])~([^\s].*?[^\s]|\S|w)~(?=[\W_]|\s|$)/g;
const MONO_REGEX = /(?<![a-zA-Z0-9])```([^\s].*?[^\s]|\S|w)```(?=[\W_]|\s|$)/g;

export function markdown(markdown) {
  // Split the Markdown text into lines
  const lines = markdown.split('\n');

  let html = '';

  // Track if we are currently in a list and the type of list
  let inList = false;
  let isBulletList = false;

  // Process each line individually
  lines.forEach((line) => {
    // Bold
    line = line.replace(BOLD_REGEX, '<strong style="font-weight:600">$1</strong>');
    // Italic
    line = line.replace(ITALIC_REGEX, '<em>$1</em>');
    // Code
    line = line.replace(MONO_REGEX, '<code>$1</code>');
    // Strikethrough
    line = line.replace(STRIKETHROUGH_REGEX, '<del>$1</del>');
    // Check if the line is a list item
    const listItemMatch = line.match(LIST_ITEM_REGEX);
    if (listItemMatch) {
      // Determine the type of list item
      const listItemType = listItemMatch[1].trim();
      if (listItemType.startsWith('-') || listItemType.startsWith('*')) {
        // If we were in an ordered list, close it
        if (inList && !isBulletList) {
          html += '</ol>';
          inList = false;
        }
        // If we are not already in a bullet list, start one
        if (!inList) {
          html += '<ul>';
          inList = true;
          isBulletList = true;
        }
        html += `<li>${listItemMatch[2]}</li>`;
      }
      else {
        // If we were in an unordered list, close it
        if (inList && isBulletList) {
          html += '</ul>';
          inList = false;
        }
        // If we are not already in an ordered list, start one
        if (!inList) {
          html += '<ol>';
          inList = true;
          isBulletList = false;
        }
        html += `<li>${listItemMatch[2]}</li>`;
      }
    }
    else {
      // If we were in a list, close the list
      if (inList) {
        html += isBulletList ? '</ul>' : '</ol>';
        inList = false;
      }
      // Regular paragraph
      html += `${line}` + '<br>';
    }
  });

  // If we were in a list at the end, close it
  if (inList) {
    html += isBulletList ? '</ul>' : '</ol>';
  }

  return html;
}
